import React, { useState, useEffect } from 'react';
import { aboutAPI } from '../services/api';

const About = () => {
  const [aboutContent, setAboutContent] = useState({ title: '', content: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const response = await aboutAPI.get();
      setAboutContent(response.data);
    } catch (error) {
      console.error('Error fetching about content:', error);
      // Set default content if API fails
      setAboutContent({
        title: 'About ISMP Server',
        content: 'ISMP (Inside Survival Multiplayer) is a thriving Minecraft community that brings together players from around the world.'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white text-xl">Loading about content...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-red-500 to-red-700 bg-clip-text text-transparent mb-4">
            {aboutContent.title}
          </h1>
        </div>

        <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 rounded-2xl p-8 md:p-12 border border-red-600/30 backdrop-blur-sm shadow-2xl">
          <div className="prose prose-lg max-w-none">
            {aboutContent.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-gray-200 leading-relaxed mb-6 text-lg">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-6 bg-gradient-to-br from-red-900/40 to-red-800/40 rounded-xl border border-red-600/20">
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-800 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Global Community</h3>
              <p className="text-gray-300 text-sm">Players from multiple countries</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-red-900/40 to-red-800/40 rounded-xl border border-red-600/20">
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-800 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428l-7.071 7.071L5.286 15.428A9.928 9.928 0 0112 3a9.928 9.928 0 016.714 12.428z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Amazing Lore</h3>
              <p className="text-gray-300 text-sm">A unique lore along with unique mechanics</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-red-900/40 to-red-800/40 rounded-xl border border-red-600/20">
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-800 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">United Community</h3>
              <p className="text-gray-300 text-sm">A united and very fun community ❤️</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
